(function(){
  var $=function(s,c){return (c||document).querySelector(s)},$$=function(s,c){return [].slice.call((c||document).querySelectorAll(s))};

  /* scroll reveal – each section picks its own effect via data-reveal */
  function reveal(root){
    var els=$$('[data-reveal]:not(.in)',root);
    if(!('IntersectionObserver' in window)){els.forEach(function(e){e.classList.add('in')});return}
    var io=new IntersectionObserver(function(en){en.forEach(function(x){if(x.isIntersecting){x.target.classList.add('in');io.unobserve(x.target)}})},{threshold:.15,rootMargin:'0px 0px -6% 0px'});
    els.forEach(function(e){io.observe(e)});
  }
  reveal();
  document.addEventListener('shopify:section:load',function(e){reveal(e.target)});

  /* mobile menu */
  var t=$('[data-menu-toggle]'),n=$('[data-nav]');
  if(t&&n)t.addEventListener('click',function(){n.classList.toggle('open')});

  /* hero slider */
  $$('[data-slider]').forEach(function(s){
    var slides=$$('.slide',s),dots=$$('.slider__dots button',s),i=0,ms=parseInt(s.dataset.interval)||6000,timer;
    function go(k){
      slides[i].classList.remove('is-active');dots[i]&&dots[i].classList.remove('on');
      i=(k+slides.length)%slides.length;
      void slides[i].offsetWidth;
      slides[i].classList.add('is-active');dots[i]&&dots[i].classList.add('on');
    }
    function play(){clearInterval(timer);if(slides.length>1)timer=setInterval(function(){go(i+1)},ms)}
    dots.forEach(function(d,k){d.addEventListener('click',function(){go(k);play()})});
    play();
  });

  /* featured carousel arrows */
  $$('[data-car]').forEach(function(b){b.addEventListener('click',function(){
    var tr=$('[data-track]',b.parentNode);tr.scrollBy({left:parseInt(b.dataset.car)*tr.clientWidth*.8,behavior:'smooth'});
  })});

  /* ajax add to cart */
  function bumpCount(){
    fetch('/cart.js').then(function(r){return r.json()}).then(function(c){
      $$('[data-cart-count]').forEach(function(el){el.textContent=c.item_count;el.classList.remove('bump');void el.offsetWidth;el.classList.add('bump')});
    });
  }
  document.addEventListener('click',function(e){
    var b=e.target.closest('[data-add]');if(!b)return;
    e.preventDefault();
    fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({id:b.dataset.add,quantity:1})})
      .then(function(r){if(!r.ok)throw 0;return r.json()}).then(function(){b.classList.add('done');setTimeout(function(){b.classList.remove('done')},900);bumpCount()}).catch(function(){window.location='/cart'});
  });

  /* product page: gallery swap + variant price flash + ajax form */
  var main=$('[data-main]');
  $$('[data-thumb]').forEach(function(b){b.addEventListener('click',function(){
    $$('[data-thumb]').forEach(function(x){x.classList.remove('on')});b.classList.add('on');
    var img=$('img',main);if(img){img.removeAttribute('srcset');img.src=b.dataset.thumb}
    main.classList.remove('swap');void main.offsetWidth;main.classList.add('swap');
  })});
  var v=$('[data-variant]'),pr=$('[data-price]');
  if(v&&pr)v.addEventListener('change',function(){
    var o=v.options[v.selectedIndex];pr.textContent=o.dataset.price;pr.classList.remove('flash');void pr.offsetWidth;pr.classList.add('flash');
  });
  var f=$('[data-product-form]');
  if(f)f.addEventListener('submit',function(e){
    e.preventDefault();var btn=$('button[type=submit]',f),old=btn.textContent;
    fetch('/cart/add.js',{method:'POST',body:new FormData(f)}).then(function(r){if(!r.ok)throw 0;return r.json()})
      .then(function(){btn.textContent='Added ✓';bumpCount();setTimeout(function(){btn.textContent=old},1400)}).catch(function(){f.submit()});
  });
})();
